<div [formGroup]="parentGroup" class="grid">
  <div class="form-group span-12">
    <label class="label" id="input-compensation">
      <ng-container i18n="@@shared.giverOffer.typeOfAssistance">Art der Assistenz</ng-container>
      <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
    </label>
    <app-segment-button-list (valueChange)="compensationControl.setValue($event); compensationControl.markAsDirty()"
      [selectableTags]="availableCompensations$ | async"
      [value]="compensationControl.value"
      labelledby="input-compensation">
    </app-segment-button-list>
  </div>

  <div class="form-group span-8">
    <label class="label" for="input-location">
      <ng-container i18n="@@shared.giverOffer.placeOfUse">Einsatzort</ng-container>
      <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr></label>
      <ng-select #locationSelect
        (keydown.delete)="clearLocation()"
        [formControl]="locationControl"
        [items]="locations$ | async"
        [typeahead]="locationInput$"
        bindLabel="zipAndName"
        class="typeahead"
        i18n-placeholder="@@shared.giverOffer.placeholder.placeOfUse"
        i18n-typeToSearchText="@@shared.giverOffer.placeholder.plzTypeToSearchText"
        labelForId="input-location"
        notFoundText="Keine Treffer"
        placeholder="Einsatzort auswählen..."
        typeToSearchText="PLZ/Ortsnamen eingeben">
      </ng-select>
      @if (locationControl.invalid && (locationControl.touched || locationControl.dirty)) {
        <div
          class="validation error"
          i18n="@@shared.giverOffer.error.placeOfUse"
          >Bitte wählen Sie Ihren Einsatzort aus.
        </div>
      }
    </div>

    <div class="form-group span-4">
      <label class="label" for="input-range">
        <ng-container i18n="@@shared.giverOffer.area">Einsatzgebiet (in km)</ng-container>
        <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
      </label>
      <ng-select
        [clearable]="false"
        [searchable]="false"
        appAddIconChevronDown
        formControlName="range"
        labelForId="input-range">
        <ng-option value="5">5</ng-option>
        <ng-option value="10">10</ng-option>
        <ng-option value="25">25</ng-option>
        <ng-option value="50">50</ng-option>
        <ng-option value="100">100</ng-option>
      </ng-select>
      @if (rangeControl.invalid && (rangeControl.touched || rangeControl.dirty)) {
        <div
          class="validation error">
          @if (rangeControl.errors.required) {
            <span i18n="@@shared.giverOffer.error.areaRquired">Bitte wählen Sie Ihren Einsatzradius aus.</span>
          }
          @if (rangeControl.errors.min) {
            <span i18n="@@shared.giverOffer.error.areaMin">Der Radius muss mindestens 1&nbsp;km betragen.</span>
          }
        </div>
      }
    </div>

    <div class="form-group span-12">
      <label class="label" id="input-assistance-services">
        <ng-container i18n="@@shared.giverOffer.assistanceServices">Ich biete Assistenz bei</ng-container>
        <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
      </label>
      <div class="form-group span-12 information-text information-text--not-shure-terms"
        i18n="@@recipientOffer.informationText.notShureTerms">Sind sie nicht ganz sicher, was die untenstehenden
            Begriffe bedeuten oder welche Aufgaben damit verbunden sind? Kein Problem <a
                    [href]="linkToFilterDescription" target="_blank">lesen sie es hier nach.</a></div>
      @if (assistanceServicesControl.invalid && (assistanceServicesControl.touched || assistanceServicesControl.dirty)) {
        <div
          class="validation error fix-margin-assistance" i18n="@@shared.giverOffer.error.assistanceServices">Bitte
            wählen Sie mindestens 1 Kategorie aus, um fortzufahren.
        </div>
      }
      <app-tag-selector
        (valueChange)="assistanceServicesControl.setValue($event); assistanceServicesControl.markAsDirty();"
        [selectableTags]="availableAssistanceServices$ | async"
        [value]="assistanceServicesControl.value"
        labelledby="input-assistance-services">
      </app-tag-selector>
    </div>
  </div>
